import React from 'react';
import { List, Paper } from '@mui/material';
import DailyCashItem from './DailyCashItem';

const MainDailyCashList = ({ cashItems, onClick }) => {
  return (
    <Paper elevation={0} sx={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'hidden', mt: 1 }}>
      <List sx={{ 
        flex: 1,
        overflow: 'auto'
      }}>
        {cashItems.map((item, index) => (
          <DailyCashItem 
            key={`${item.id}-${index}`} 
            item={item} 
            onItemClick={onClick} 
          />
        ))}
      </List>
    </Paper>
  );
};

export default MainDailyCashList; 